import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

type AddressProps = {
  index1: number
  index2: number
}

export const Address = ({ index1, index2 }: AddressProps) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.address`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="11. Address"
          input={(props) => <TextInput {...props} disabled={isAllInfoUnavailable} maxLength={100} />}
        />
      )}
    />
  )
}
